import * as React from 'react';
import * as _ from 'underscore';

import { ButtonType, ButtonWidget, InteractionState, Tooltip, TooltipPosition } from '@tableau/widgets';
import { Messages } from '../../codegen/Localize';
import { Location } from '../../common/react/Location';
import { PageHeaderButtonClickEvent, TelemetryEvents } from '../../common/telemetryEvents/TelemetryEvents';
import { imgPath } from '../../common/utilities/ImgUrl';
import { Telemetry } from '../../ts/services/TelemetryService';
import { PreviousUrlInitialState } from '../reducers/PreviousUrlReducer';
import { ServerUrls } from '../ServerUrls';
import { SpacesSiteUrls } from '../spaces/SpacesSiteUrls';
import { PageHeaderButtonType } from './PageHeader';
import { PageHeaderStyles } from './PageHeaderStyles';

export const iconHeight: number = 24;
export interface BackButtonProps {
  readonly previousUrl: string;
  readonly parentId: string;
  readonly siteUrls: SpacesSiteUrls;
  readonly serverUrls: ServerUrls;
  readonly isOnDatasourceAnalyticsViz: boolean;
  readonly isOnSiteStatusViz: boolean;
  readonly isOnServerStatusViz: boolean;
  readonly isMetricDetail: boolean;
  readonly telemetryService: Telemetry;
  readonly buttonType: PageHeaderButtonType;
  readonly styleOverrides?: React.CSSProperties;
  readonly wrapperDivStyleOverrides?: React.CSSProperties;
}

export class BackButton extends React.PureComponent<BackButtonProps> {
  static readonly LIGHT_ICON_PATH: string = imgPath('spaces_toolbar_back_white.svg');
  static readonly LIGHT_ICON_PATH_ACTIVE: string = imgPath('spaces_toolbar_back_white_active.svg');

  static readonly REGULAR_ICON_PATH: string = imgPath('spaces_toolbar_back.svg');
  static readonly REGULAR_ICON_PATH_ACTIVE: string = imgPath('spaces_toolbar_back_active.svg');

  public render() {
    return (
      <Tooltip getContent={this.getTooltipContent} position={TooltipPosition.BottomRightCorner} testId={'back-button-tooltip'} >
        <div style={{...PageHeaderStyles.BackButtonWrapperDiv, ...this.props.wrapperDivStyleOverrides}}>
          <ButtonWidget
            buttonType={ButtonType.IconOutline}
            testId="back"
            getContent={this.getButtonContent}
            handleClick={this.handleClick}
            style={{...PageHeaderStyles.BackButton, ...this.props.styleOverrides}}
          />
        </div>
      </Tooltip>);
  }

  private getButtonContent = (state: InteractionState): JSX.Element => {
    const useActiveIcon: boolean = state.hover || state.active || state.focus;
    return (
      <div aria-label={ Messages.back() }>
        {this.props.buttonType === 'light' && <img src={useActiveIcon ? BackButton.LIGHT_ICON_PATH_ACTIVE : BackButton.LIGHT_ICON_PATH} style={{border: '1px solid transparent'}} />}
        {this.props.buttonType === 'regular' && <img width={24} height={24} src={useActiveIcon ? BackButton.REGULAR_ICON_PATH_ACTIVE : BackButton.REGULAR_ICON_PATH} style={{border: '1px solid transparent'}}/>}
      </div>);
  }

  private handleClick = (): void => {
    let url: string = '';

    if (this.props.isOnSiteStatusViz) {
      url = this.props.siteUrls.statusUrl();

    } else if (this.props.isOnServerStatusViz) {
      url = this.props.serverUrls.statusUrl();

    } else if (this.props.previousUrl === PreviousUrlInitialState) {
      if (this.props.isOnDatasourceAnalyticsViz) {
        url = this.props.siteUrls.datasourceUrl(this.props.parentId);
      } else if (this.props.isMetricDetail) {
        url = this.props.siteUrls.metricsAllUrl();
      } else {
        url = this.props.siteUrls.workbookUrl(this.props.parentId);
      }

    } else {
      url = this.props.previousUrl;
    }

    this.props.telemetryService.sendEvent<PageHeaderButtonClickEvent>({
      type: TelemetryEvents.PageHeaderButtonClick,
      button: 'back-button',
      action: 'open'
    });

    Location.instance.setUrl(url);
  }

  private getTooltipContent = (): JSX.Element => {
    return (
    <span>
      {Messages.back()}
    </span>);
  }
}
